import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'
import { CheckoutMethod, NextPlanId, TriggerFeature } from '../types'

export interface Properties extends GA4GeneralProps {
  checkoutMethod: CheckoutMethod
  nextPlansIds: NextPlanId[]
  triggerFeature: TriggerFeature
}

export class GA4ViewItemEvent extends GA4Event {
  ga4_checkout_method: CheckoutMethod
  ga4_next_plan_id: { item_id: string; item_name: 'next_plan_id' }[]
  ga4_trigger_feature: TriggerFeature

  constructor({ checkoutMethod, nextPlansIds, triggerFeature, ...generalProps }: Properties) {
    super({ event: EVENT.VIEW_ITEM, ...generalProps })

    this.ga4_checkout_method = checkoutMethod
    this.ga4_trigger_feature = triggerFeature
    this.ga4_next_plan_id = nextPlansIds
      .filter((nextPlanId): nextPlanId is number => typeof nextPlanId === 'number')
      .map((nextPlanId) => ({
        item_id: `${nextPlanId}`,
        item_name: 'next_plan_id',
      }))
  }
}
